if (!customElements.get('product-size-guide')) {
  class ProductSizeGuide extends HTMLElement {
    connectedCallback() {
      this.baseUnit = this.dataset.baseUnit === 'in' ? 'in' : 'cm';
      this.buttons = Array.from(this.querySelectorAll('[data-size-unit]'));
      this.measurements = Array.from(this.querySelectorAll('[data-size-measurement]'));

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.setUnit(button.dataset.sizeUnit));
      });

      this.setUnit(this.dataset.defaultUnit === 'cm' ? 'cm' : 'in');
    }

    setUnit(unit) {
      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.sizeUnit === unit ? 'true' : 'false');
      });

      this.measurements.forEach((measurement) => {
        const explicitValue = unit === 'cm' ? measurement.dataset.cmValue : measurement.dataset.inValue;
        if (explicitValue) {
          measurement.textContent = explicitValue;
          return;
        }

        const sourceValue = Number.parseFloat(measurement.dataset.value);
        if (!Number.isFinite(sourceValue)) return;

        let displayValue = sourceValue;
        if (this.baseUnit === 'cm' && unit === 'in') displayValue = sourceValue / 2.54;
        if (this.baseUnit === 'in' && unit === 'cm') displayValue = sourceValue * 2.54;

        const precision = unit === this.baseUnit ? 2 : 1;
        measurement.textContent = Number(displayValue.toFixed(precision)).toString();
      });
    }
  }

  customElements.define('product-size-guide', ProductSizeGuide);
}
